'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

const React = require('react');
const React__default = _interopDefault(React);

/**
 * A custom hook that triggers a callback whenever a change is detected after initial mount
 * Similar to componentDidUpdate
 * (useEffect triggers on initial render)
 *
 * @param {Function} callback The callback triggered on change
 * @param {Array} deps The prop to watch for updates
 */
var useDidUpdate = function useDidUpdate(callback, deps) {
  var hasMounted = React.useRef(false);
  React.useEffect(function () {
    if (hasMounted.current) {
      callback();
    } else {
      hasMounted.current = true;
    }
  }, deps);
};

module.exports = useDidUpdate;
